<div class="container">
  <div class="content">
    <div class="title-row">
      <span class="ktitle-tiny">Buildings & Requirements</span>
      <span class="klabel-medium">*Required field</span>
    </div>
    <span class="kbody-large description"
      >Users can be assigned to more than one building and more than one
      position. The ‘star’ icon indicates the primary selection for that user.
      To change the primary selection, simply click on a selection item.</span
    >
    <span class="klabel-huge">Buildings</span>
    <span class="klabel-medium label">Select buildings*</span>
    <div class="input-select-container kinput">
      <input
        [disabled]="isEditMode && !permissions.USER_EDIT"
        #buildinginput
        (change)="addBuilding($event)"
        class="kinput kbody-medium input-select"
        type="text"
        placeholder="Type or select a building"
        list="targets"
      />
      <datalist id="targets" class="datalist">
        <option
          class="kbody-medium"
          *ngFor="let building of buildings"
          [value]="building.id"
        >
          {{ building.buildingName }}
        </option>
      </datalist>
    </div>
    <span class="klabel-medium label" *ngIf="user.primaryBuildingId"
      >Selections</span
    >
    <div class="chips">
      <app-chip
        *ngIf="user.primaryBuildingId"
        (closeChip)="removeBuilding(user.primaryBuildingId)"
        [closable]="true"
        [text]="getBuildingName(user.primaryBuildingId)"
        [icon]="{ type: 'star' }"
        [disabled]="isEditMode && !permissions.USER_EDIT"
      >
      </app-chip>
      <app-chip
        *ngFor="
          let buildingId of filterPrimaryAsset(
            user.buildingIds,
            user.primaryBuildingId
          )
        "
        (closeChip)="removeBuilding(buildingId)"
        [closable]="true"
        [text]="getBuildingName(buildingId)"
        (click)="togglePrimaryAsset(buildingId, 'building')"
        [class]="'outlined'"
        [disabled]="isEditMode && !permissions.USER_EDIT"
      >
      </app-chip>
    </div>

    <span class="klabel-huge">Positions</span>
    <span class="klabel-medium label">Select positions*</span>
    <div class="input-select-container kinput">
      <input
        [disabled]="isEditMode && !permissions.USER_EDIT"
        #positioninput
        (change)="addPosition($event)"
        class="kinput kbody-medium input-select"
        type="text"
        placeholder="Type or select a position"
        list="positiontargets"
      />
      <datalist id="positiontargets" class="datalist">
        <option
          class="kbody-medium"
          *ngFor="let position of positions"
          [value]="position.id"
        >
          {{ position.positionTitle }}
        </option>
      </datalist>
    </div>
    <span class="klabel-medium label" *ngIf="user.primaryPositionId"
      >Selections</span
    >
    <div class="chips">
      <app-chip
        *ngIf="user.primaryPositionId"
        (closeChip)="removePosition(user.primaryPositionId)"
        [closable]="true"
        [text]="getPositionName(user.primaryPositionId)"
        [icon]="{ type: 'star' }"
        [disabled]="isEditMode && !permissions.USER_EDIT"
      >
      </app-chip>
      <app-chip
        *ngFor="
          let positionId of filterPrimaryAsset(
            user.positionIds,
            user.primaryPositionId
          )
        "
        (closeChip)="removePosition(positionId)"
        [closable]="true"
        [text]="getPositionName(positionId)"
        (click)="togglePrimaryAsset(positionId, 'position')"
        [class]="'outlined'"
        [disabled]="isEditMode && !permissions.USER_EDIT"
      >
      </app-chip>
    </div>
  </div>
  <div class="buttons">
    <app-button
      (click)="stepBackward()"
      [text]="'Previous Step'"
      [icon]="{ materialIcon: 'arrow_back' }"
      [class]="'white'"
    ></app-button>
    <div class="actions">
      <app-button
        [text]="'Cancel'"
        [class]="'white'"
        (click)="closeDialog()"
      ></app-button>
      <app-button
        [disabled]="
          !this.user.primaryBuildingId || !this.user.primaryPositionId
        "
        [icon]="{ materialIcon: 'arrow_forward' }"
        [class]="'icon-right'"
        [text]="'Next Step'"
        (click)="updateUser()"
      ></app-button>
    </div>
  </div>
</div>
